import FilterModel from './filter.model'

let storeContent = utils.generateStore({
   FilterModel,
   filters: [],
   selected_filters: [],
   show_edit_options: false
})

export default {
   state() {
      return {
         ...storeContent.state
      };
   },
   getters: {
      ...storeContent.getters
   },
   mutations: {
      ...storeContent.mutations
   },
   actions: {
      async addFilter(ctx, payload) {
         try {
            ctx.commit('loading', true)
            let data = payload.ref.form_data_

            if (await payload.ref.isValid()) {
               let res = await api.fetchEndpoint({
                  resource: 'commons',
                  action: 'insert',
                  data: {
                     record: {
                        name: data.name,
                        field: data.field,
                        type: data.type,
                        table: data.table,
                        has_multiple: data.has_multiple,
                        description: data.description,
                     }
                  },
                  meta_data: {
                     service: "analytics",
                     collection: "filter",
                  }
               })

               await payload.ref.resetForms()
               await ctx.dispatch('fetchFilter')
               ctx.commit('show_create_modal', false)
               $notify('success', 'Filter Created', `Filter ${data.name} successfully created.`, 5)
            }

            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      async updateFilter(ctx, payload) {
         try {
            ctx.commit('loading', true)
            let data = payload.ref.form_data_

            if (await payload.ref.isValid()) {
               let res = await api.fetchEndpoint({
                  resource: 'commons',
                  action: 'update',
                  data: {
                     id: ctx.getters.selected_filters[0]._id,
                     record: {
                        name: data.name,
                        field: data.field,
                        type: data.type,
                        table: data.table,
                        has_multiple: data.has_multiple,
                        description: data.description,
                     }
                  },
                  meta_data: {
                     service: "analytics",
                     collection: "filter",
                  }
               })

               await payload.ref.resetForms()
               await ctx.dispatch('fetchFilter')
               ctx.commit('show_edit_modal', false)
               $notify('success', 'Filter Updated', `Filter ${data.name} successfully updated.`, 5)
            }

            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      async deleteFilter(ctx, payload) {
         try {
            ctx.commit('loading', true)

            for (const filter of ctx.getters.selected_filters) {
               let res = await api.fetchEndpoint({
                  resource: 'commons',
                  action: 'delete',
                  data: {
                     id: filter._id,
                  },
                  meta_data: {
                     service: "analytics",
                     collection: "filter",
                  }
               })
            }

            await ctx.dispatch('fetchFilter')
            ctx.commit('show_delete_modal', false)
            $notify('success', 'Filter Deleted', `<b>${ctx.getters.selected_filters.length}</b> Filter successfully deleted.`, 5)

            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      handleActions(ctx, payload) {
         if (payload.action === 'filter:edit') {
            let FilterModel = ctx.getters.FilterModel
            FilterModel.forms.editFilter.data = payload.rows[0]

            ctx.commit('FilterModel', FilterModel)
            ctx.commit('show_edit_modal', true)
            ctx.commit('selected_filters', payload.rows)
         } else if (payload.action === 'filter:delete') {
            ctx.commit('delete_message', `<b>${payload.rows.length}</b> Filter`)
            ctx.commit('show_delete_modal', true)
            ctx.commit('selected_filters', payload.rows)
         } else if (payload.action === 'filter:view') {
            // $session.set('selected_filters',payload.rows[0])
         } else if (payload.action === 'filter:fetch_options') {
            ctx.commit('selected_filters', payload.rows)
            ctx.dispatch('fetchOptions')
         } else if (payload.action === 'filter:edit_options') {
            let FilterModel = ctx.getters.FilterModel
            FilterModel.forms.edit_options.data = payload.rows[0]

            ctx.commit('FilterModel', FilterModel)
            ctx.commit('show_edit_options', true)
            ctx.commit('selected_filters', payload.rows)
         }
      },
      async fetchOptions(ctx) {
         try {
            Event.$emit('loader:show', true)

            for (const filter of ctx.getters.selected_filters) {
               let res = await api.fetchEndpoint({
                  resource: 'table',
                  action: 'get:filter_options',
                  data: {
                     filter_id: filter._id,
                  },
                  meta_data: {}
               })

               $notify('success', 'Filter Options Fetched', `Options for Filter: <b>${res.result.filter.name}</b> successfully fetched.`, 5)
            }

            await ctx.dispatch('fetchFilter')
            Event.$emit('loader:show', false)
         } catch (err) {
            Event.$emit('loader:show', false)
            throw err
         }
      },
      async fetchFilter(ctx) {
         try {
            let res = await api.fetchEndpointSecure({
               resource: 'commons',
               action: 'list',
               data: {
                  rules: {
                     match: {

                     }
                  }
               },
               meta_data: {
                  service: "analytics",
                  collection: "filter",
               }
            })
            ctx.commit('filters', res.result.records);
         } catch (err) {
            throw err
         }
      },
      async fetchFormData(ctx) {
         try {
            // Fetch Schema
            let res = await api.fetchEndpointSecure({
               resource: 'commons',action: 'list',
               data: {
                  rules: {
                     match: {
                        is_accessible: true
                     }
                  }
               },
               meta_data: {service: "analytics",collection: "table"}
            })


            let Model = utils.appendSelectData({
               Model: ctx.getters.FilterModel,
               forms: ['addFilter','editFilter'],
               model: 'table',
               label: 'name',
               dataField: 'code',
               data: res.result.records
            })
            ctx.commit('FilterModel', Model)
         } catch (err) {
            throw err
         }
      },
      async selectFieldChanged(ctx,payload){
         try {
            if(payload.form.model === 'table' && payload.data && payload.data.length > 3){
               ctx.commit('loading',true)
               await ctx.dispatch('fetchTableFields',payload.data)
               ctx.commit('loading',false)
            }
         } catch (err) {
            throw err
         }
      },
      async fetchTableFields(ctx,table_code) {
         try {
            // Fetch Schema
            let res = await api.fetchEndpointSecure({
               resource: 'commons',
               action: 'list',
               data: {
                  rules: {
                     match: {table_code}
                  }
               },
               meta_data: {
                  service: "analytics",
                  collection: "field",
               }
            })

            let Model = utils.appendSelectData({
               Model: ctx.getters.FilterModel,
               forms: ['addFilter','editFilter'],
               model: 'field',
               label: 'name',
               dataField: 'name',
               data: res.result.records
            })
            ctx.commit('FilterModel', Model)
         } catch (err) {
            throw err
         }
      },
      async fetchData(ctx) {
         try {
            await ctx.dispatch('fetchFormData')
            await ctx.dispatch('fetchFilter')
            Event.$emit('loader:show', false)
         } catch (err) {
            throw err
         }
      },
   }
};